// src/App.js
import React from "react";
import "./App.css"; // Import des styles globaux (inclut .gratuit-hero)
import AuthProvider from "./context/AuthContext";
import Header from "./components/Header.jsx";
import { Outlet } from "react-router-dom";

export default function App() {
  return (
    <AuthProvider>
      <Header />
      <Outlet />
    </AuthProvider>
  );
}
